import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DollarSign } from "lucide-react";

export const CashWithdrawalDialog = ({
  open, onOpenChange,
  withdrawalAmount, setWithdrawalAmount,
  withdrawalFeeRate, setWithdrawalFeeRate,
  withdrawalFromTill, setWithdrawalFromTill,
  onAddWithdrawal,
}) => {
  const amt = parseFloat(withdrawalAmount) || 0;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-purple-700">
            <DollarSign className="h-5 w-5" /> Cash Withdrawal
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-xs font-medium text-gray-500 uppercase">Withdrawal Amount (R)</label>
            <Input
              type="number" step="0.01" min="0"
              placeholder="e.g. 200.00"
              value={withdrawalAmount}
              onChange={(e) => setWithdrawalAmount(e.target.value)}
              className="mt-1 text-lg" autoFocus
              data-testid="withdrawal-amount-input"
              onKeyDown={(e) => e.key === 'Enter' && onAddWithdrawal()}
            />
          </div>
          <div className="flex items-center gap-2">
            <label className="text-xs font-medium text-gray-500 uppercase">Service Fee (%)</label>
            <Input
              type="number" step="0.5" min="0" max="100"
              value={withdrawalFeeRate}
              onChange={(e) => setWithdrawalFeeRate(parseFloat(e.target.value) || 0)}
              className="w-20 text-center h-8"
              data-testid="withdrawal-fee-input"
            />
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500 uppercase mb-2 block">Where does the cash come from? *</label>
            <div className="grid grid-cols-2 gap-2">
              <button type="button" onClick={() => setWithdrawalFromTill(true)}
                className={`p-3 rounded-lg border-2 text-center transition-all ${withdrawalFromTill === true ? 'border-purple-500 bg-purple-50 ring-2 ring-purple-200' : 'border-gray-200 hover:border-gray-300'}`}
                data-testid="withdrawal-source-till">
                <div className="font-semibold text-sm">{withdrawalFromTill === true ? '✓ ' : ''}TILL</div>
                <div className="text-[10px] text-gray-500">Affects cash-up</div>
              </button>
              <button type="button" onClick={() => setWithdrawalFromTill(false)}
                className={`p-3 rounded-lg border-2 text-center transition-all ${withdrawalFromTill === false ? 'border-green-500 bg-green-50 ring-2 ring-green-200' : 'border-gray-200 hover:border-gray-300'}`}
                data-testid="withdrawal-source-safe">
                <div className="font-semibold text-sm">{withdrawalFromTill === false ? '✓ ' : ''}BACK SAFE</div>
                <div className="text-[10px] text-gray-500">Till not affected</div>
              </button>
            </div>
          </div>
          {amt > 0 && (
            <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 space-y-1">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Withdrawal:</span>
                <span className="font-mono">R {amt.toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Service Fee ({withdrawalFeeRate}%):</span>
                <span className="font-mono text-purple-700">R {(amt * withdrawalFeeRate / 100).toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-base font-bold border-t border-purple-300 pt-1 mt-1">
                <span>Customer Pays:</span>
                <span className="text-purple-800 font-mono">R {(amt * (1 + withdrawalFeeRate / 100)).toFixed(2)}</span>
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onAddWithdrawal} disabled={!withdrawalAmount || amt <= 0 || withdrawalFromTill === null}
            className="bg-purple-600 hover:bg-purple-700" data-testid="withdrawal-add-btn">
            Add Withdrawal to Cart
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
